export const APPOINTMENT_STATUS = {
  Booked: "BOOKED",
  BookedByMBS: "BOOKED_BY_MBS",
  Moved: "MOVED",
  MovedByClinic: "MOVED_BY_CLINIC",
  MovedByPatient: "MOVED_BY_PATIENT",
  MovedByMBS: "MOVED_BY_MBS",
  Cancelled: "CANCELLED",
  CancelledByClinic: "CANCELLED_BY_CLINIC",
  CancelledByPatient: "CANCELLED_BY_PATIENT",
  CancelledByMBS: "CANCELLED_BY_MBS",
  Completed: "COMPLETED",
  Unknown: "UNKNOWN",
};

export const BOOKED_STATUS = [
  APPOINTMENT_STATUS.Booked,
  APPOINTMENT_STATUS.BookedByMBS,
];

export const MOVED_STATUS = [
  APPOINTMENT_STATUS.Moved,
  APPOINTMENT_STATUS.MovedByClinic,
  APPOINTMENT_STATUS.MovedByPatient,
  APPOINTMENT_STATUS.MovedByMBS,
];

export const CANCELLED_STATUS = [
  APPOINTMENT_STATUS.Cancelled,
  APPOINTMENT_STATUS.CancelledByClinic,
  APPOINTMENT_STATUS.CancelledByPatient,
  APPOINTMENT_STATUS.CancelledByMBS,
];

export const APPOINTMENT_INACTIVE_STATUS = [
  APPOINTMENT_STATUS.Completed,
  ...CANCELLED_STATUS,
];
export const APPOINTMENT_ACTIVE_STATUS = [...BOOKED_STATUS, ...MOVED_STATUS];

export const APPOINTMENT_AVAILABILITY_STATUS = {
  ONLINE_AVAILABLE: "ONLINE_AVAILABLE",
  WALK_IN_AVAILABLE: "WALK_IN_AVAILABLE",
  FULLY_BOOKED: "FULLY_BOOKED",
};
export const AVAILABILITY_STATUS_PRIORITY = {
  [APPOINTMENT_AVAILABILITY_STATUS.ONLINE_AVAILABLE]: 0,
  [APPOINTMENT_AVAILABILITY_STATUS.WALK_IN_AVAILABLE]: 1,
  [APPOINTMENT_AVAILABILITY_STATUS.FULLY_BOOKED]: 2,
};
